import React from "react";
import { ArrowUp } from "@piiqtechnologies/svg-icons";
import { PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const ChangeIndicator = ({ changePercentage, isFullColored = true, hideNull = true, isPercentage = true, }) => {
    const theme = useTheme();
    if (changePercentage === undefined || changePercentage === null) {
        if (hideNull)
            return React.createElement(React.Fragment, null);
        return React.createElement(PeekTypography, { color: theme.palette.info.main }, "N/A");
    }
    const variant = changePercentage > 0 ? "success" : changePercentage < 0 ? "error" : "info";
    const color = theme.palette[variant].main;
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.25, alignItems: "center" },
        changePercentage !== 0 && (React.createElement(ArrowUp, { style: {
                transform: changePercentage < 0 ? "rotate(180deg)" : "none",
            }, color: color })),
        React.createElement(PeekTypography, { color: isFullColored ? color : theme.palette.info.main },
            changePercentage,
            isPercentage ? "%" : "")));
};
export default ChangeIndicator;
